import React, { Component } from "react";
import { Modal, Select, Input, DatePicker, message, Spin, Checkbox, Row, Col } from "antd";
import SearchRetrieve from "../../common/SearchRetrieve.new";
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";
import moment from "moment";

const { Option } = Select;
const dateFormat = "YYYY-MM-DD";
const phoneRegex = /^[0-1]\d{10}$/;

let editRecord = null;

class PendingDoctorModal extends Component {
    state = {
        visible: false,
        submitting: false,
        params: {},
        courtyardList: [],
        courtyardMap: {},
        needCourtyard: false,
        courtyardDisabled: false,
        deptList: [],
        deptLoading: false,
        disableMobile: false,
        disableCheckBox: false,
    };

    show = (record) => {
        editRecord = record || null;
        const params = {
            hospitalPendingCooperationId: record ? record.hospitalId : undefined,
            hospitalName: record ? record.hospitalName : undefined,
            courtyardArea: record ? record.courtyardArea : undefined,
            hospitalDepartmentId: record ? record.hospitalDepartmentId : undefined,
            deptName: record ? record.deptName : undefined,
            doctorName: record ? record.doctorName : undefined,
            gender: record ? record.gender : undefined,
            birthDate: record && record.birthDate ? moment(record.birthDate) : undefined,
            professionalTitle: record ? record.professionalTitle : undefined,
            doctorPosition: record ? record.doctorPosition : undefined,
            userMobile: record ? record.userMobile : undefined,
            userTelephone: record ? record.userTelephone : undefined,
            userEmail: record ? record.userEmail : undefined,
            receptionTime: record ? record.receptionTime : undefined,
            receptionPlace: record ? record.receptionPlace : undefined,
        };

        this.setState({
            visible: true,
            params,
            courtyardList: [],
            courtyardMap: {},
            needCourtyard: false,
            courtyardDisabled: false,
            deptList: [],
            submitting: false,
            disableMobile: false,
            disableCheckBox: false,
        }, () => {
            if (record && record.hospitalName) {
                this.queryCourtyardAreaList(record.hospitalName);
                if (record.hospitalId) {
                    this.queryDeptList(record.hospitalId);
                }
            }
        });
    };

    hide = () => {
        editRecord = null;
        this.setState({
            visible: false,
            courtyardList: [],
            courtyardMap: {},
            needCourtyard: false,
            courtyardDisabled: false,
            deptList: [],
            disableMobile: false,
            disableCheckBox: false,
        });
    };

    queryCourtyardAreaList = (hospitalName) => {
        if (!hospitalName) return;
        $.sendRequest({
            method: "POST",
            url: API_URL.hospital.pendingCooperationCourtyardListForAdd,
            data: { limit: 50, offset: 1, equHospitalName: hospitalName },
            dataType: "json",
            doneResult: (res) => {
                const datas = res.datas || [];
                const courtyardMap = {};
                datas.forEach((i) => {
                    if (i.courtyardArea) {
                        courtyardMap[i.courtyardArea] = i.hospitalPendingCooperationId;
                    }
                });
                const courtyardAreas = Object.keys(courtyardMap);
                const hasCourtyard = courtyardAreas.length > 0;
                let courtyardDisabled = false;
                const { params } = this.state;

                // 如果只有一个院区，默认选中且不可编辑
                if (courtyardAreas.length === 1 && !params.courtyardArea) {
                    params.courtyardArea = courtyardAreas[0];
                    params.hospitalPendingCooperationId = courtyardMap[courtyardAreas[0]];
                    courtyardDisabled = true;
                    this.queryDeptList(params.hospitalPendingCooperationId);
                } else if (courtyardAreas.length === 0 && datas.length === 1 && !datas[0].courtyardArea) {
                    // 无院区但只有一条记录，直接取该条记录的ID
                    params.hospitalPendingCooperationId = datas[0].hospitalPendingCooperationId;
                    courtyardDisabled = true;
                    this.queryDeptList(params.hospitalPendingCooperationId);
                }

                this.setState({
                    courtyardList: datas,
                    courtyardMap,
                    needCourtyard: hasCourtyard,
                    courtyardDisabled,
                    params,
                });
            },
        });
    };

    queryDeptList = (hospitalPendingCooperationId) => {
        if (!hospitalPendingCooperationId) return;
        this.setState({ deptLoading: true });
        $.sendRequest({
            method: "POST",
            url: API_URL.hospital.deptPendingCooperationListByHospitalId,
            data: { hospitalId: hospitalPendingCooperationId },
            dataType: "json",
            doneResult: (res) => {
                const datas = res.datas || [];
                this.setState({ deptList: datas, deptLoading: false });
                // If only one dept and none selected, auto-select
                if (datas.length === 1 && !this.state.params.hospitalDepartmentId) {
                    const { params } = this.state;
                    params.hospitalDepartmentId = datas[0].hospitalDeptPendingCooperationId;
                    params.deptName = datas[0].deptName;
                    this.setState({ params });
                }
            },
            errorResult: () => {
                this.setState({ deptLoading: false });
            },
        });
    };

    submit = () => {
        const { params, needCourtyard, disableMobile } = this.state;
        const { hospitalPendingCooperationId, hospitalDepartmentId, courtyardArea, doctorName, userMobile } = params;
        if (!hospitalPendingCooperationId) { message.warning("请选择医院"); return; }
        if (needCourtyard && !courtyardArea) { message.warning("请选择院区"); return; }
        if (!hospitalDepartmentId) { message.warning("请选择科室"); return; }
        if (!doctorName || !doctorName.trim()) { message.warning("请输入医生姓名"); return; }
        if (!userMobile || !userMobile.trim()) { message.warning("请输入手机号码"); return; }
        if (!disableMobile && !phoneRegex.test(userMobile)) { message.warning("请填写正确的手机号码！"); return; }

        this.setState({ submitting: true });
        const url = editRecord
            ? API_URL.hospital.doctorPendingCooperationUpdate
            : API_URL.hospital.doctorPendingCooperationAdd;
        const submitData = {
            hospitalId: hospitalPendingCooperationId,
            hospitalDepartmentId: hospitalDepartmentId,
            doctorName: (params.doctorName || "").trim(),
            gender: params.gender,
            professionalTitle: params.professionalTitle,
            doctorPosition: (params.doctorPosition || "").trim(),
            userMobile: (params.userMobile || "").trim(),
            userTelephone: (params.userTelephone || "").trim(),
            userEmail: (params.userEmail || "").trim(),
            receptionTime: (params.receptionTime || "").trim(),
            receptionPlace: (params.receptionPlace || "").trim(),
        };
        if (params.birthDate) {
            submitData.birthDate = moment(params.birthDate).format(dateFormat);
        }
        if (editRecord) {
            submitData.doctorPendingCooperationId = editRecord.doctorPendingCooperationId;
        }

        $.sendRequest({
            method: "POST",
            url,
            data: submitData,
            dataType: "json",
            doneResult: (res) => {
                message.success(editRecord ? "修改成功" : "新增成功");
                this.setState({ submitting: false }, () => {
                    this.hide();
                    if (this.props.loadData) this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ submitting: false });
            },
        });
    };

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    };

    onGetPhone = (e) => {
        const { params } = this.state;
        if (e.target.checked) {
            this.setState({
                disableMobile: true,
                disableCheckBox: true,
            });
            params.userMobile = '';
            $.sendRequest({
                url: API_URL.user.getRandomUserMobile,
                data: {},
                dataType: 'json',
                doneResult: res => {
                    params.userMobile = res.userMobile || '';
                    this.setState({ params, disableCheckBox: false });
                },
                errorResult: () => {
                    this.setState({ disableCheckBox: false });
                }
            });
        } else {
            this.setState({ disableMobile: false });
            params.userMobile = '';
            this.setState({ params });
        }
    };

    handleValueChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    };

    handleDateChange = (date, key) => {
        const { params } = this.state;
        params[key] = date;
        this.setState({ params });
    };

    handleCourtyardChange = (value) => {
        const { params, courtyardMap } = this.state;
        params.courtyardArea = value;
        if (courtyardMap && courtyardMap[value]) {
            params.hospitalPendingCooperationId = courtyardMap[value];
            params.hospitalDepartmentId = undefined;
            params.deptName = undefined;
            this.setState({ params, deptList: [] }, () => {
                this.queryDeptList(params.hospitalPendingCooperationId);
            });
        } else {
            this.setState({ params });
        }
    };

    handleHospitalChange = (options) => {
        const { params } = this.state;
        // listForAdd 接口返回的 value 和 text 都是 hospitalName（不返回ID）
        params.hospitalName = options.text;
        params.hospitalPendingCooperationId = undefined; // 将在选择院区后确定
        params.courtyardArea = undefined;
        params.hospitalDepartmentId = undefined;
        params.deptName = undefined;
        this.setState({
            params,
            courtyardList: [],
            courtyardMap: {},
            needCourtyard: false,
            courtyardDisabled: false,
            deptList: [],
        }, () => {
            if (options.text) {
                this.queryCourtyardAreaList(options.text);
            }
        });
    };

    handleDeptChange = (value) => {
        const { params, deptList } = this.state;
        params.hospitalDepartmentId = value;
        const dept = deptList.find((d) => d.hospitalDeptPendingCooperationId === value);
        params.deptName = dept ? dept.deptName : undefined;
        this.setState({ params });
    };

    getContent = () => {
        const { params, visible, needCourtyard, courtyardDisabled, deptList, deptLoading, disableMobile } = this.state;
        const {
            hospitalName, courtyardArea, deptName, doctorName, gender, birthDate,
            professionalTitle, doctorPosition, userMobile, userTelephone, userEmail,
            receptionTime, receptionPlace,
        } = params;
        const asterisk = <span style={{ color: "red" }}>*</span>;

        const courtyardOptions = Object.keys(this.state.courtyardMap).map((ca) => (
            <Option key={ca}>{ca}</Option>
        ));

        const deptOptions = deptList.map((d) => (
            <Option key={d.hospitalDeptPendingCooperationId} value={d.hospitalDeptPendingCooperationId}>{d.deptName}</Option>
        ));

        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>{asterisk}医院名称:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            <SearchRetrieve
                                keyword="hospitalName"
                                style={{ width: 260 }}
                                params={{ limit: 10, offset: 1 }}
                                placeholder="输入医院名称检索"
                                url={API_URL.hospital.pendingCooperationListForAdd}
                                value={hospitalName}
                                config={{ id: "hospitalName", name: "hospitalName" }}
                                onChange={this.handleHospitalChange}
                            />
                        )}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>{needCourtyard ? asterisk : null}院区名称:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible &&
                            (needCourtyard ? (
                                <Select
                                    allowClear={true}
                                    style={{ width: 260 }}
                                    placeholder="请选择院区"
                                    disabled={courtyardDisabled}
                                    value={courtyardArea}
                                    onChange={this.handleCourtyardChange}
                                >
                                    {courtyardOptions}
                                </Select>
                            ) : (
                                <Input style={{ width: 260 }} placeholder="无院区" disabled value="" />
                            ))}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>{asterisk}科室:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            <Select
                                allowClear={true}
                                style={{ width: 260 }}
                                placeholder="请选择科室"
                                value={params.hospitalDepartmentId}
                                loading={deptLoading}
                                notFoundContent={deptLoading ? <Spin size="small" /> : "请先选择医院及院区"}
                                onChange={this.handleDeptChange}
                            >
                                {deptOptions}
                            </Select>
                        )}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>{asterisk}医生姓名:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Input
                            style={{ width: 260 }}
                            placeholder="请输入"
                            value={doctorName}
                            onChange={(e) => this.handleInputChange(e, "doctorName")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>性别:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Select
                            style={{ width: 120 }}
                            placeholder="请选择"
                            value={gender}
                            onChange={(value) => this.handleValueChange(value, "gender")}
                        >
                            <Option value="MALE">男</Option>
                            <Option value="FEMALE">女</Option>
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>出生日期:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <DatePicker
                            style={{ width: 160 }}
                            placeholder="请选择"
                            value={birthDate}
                            onChange={(date) => this.handleDateChange(date, "birthDate")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>专业技术职称:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Select
                            style={{ width: 160 }}
                            placeholder="请选择"
                            value={professionalTitle}
                            onChange={(value) => this.handleValueChange(value, "professionalTitle")}
                        >
                            <Option value="正高级">正高级</Option>
                            <Option value="副高级">副高级</Option>
                            <Option value="中级">中级</Option>
                            <Option value="初级">初级</Option>
                            <Option value="其他">其他</Option>
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>职务:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Input
                            style={{ width: 260 }}
                            placeholder="请输入"
                            value={doctorPosition}
                            onChange={(e) => this.handleInputChange(e, "doctorPosition")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>{asterisk}手机号码:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Input
                            style={{ width: 260 }}
                            placeholder="请输入"
                            maxLength={11}
                            disabled={disableMobile}
                            value={userMobile}
                            onChange={(e) => this.handleInputChange(e, "userMobile")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}></div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Checkbox
                            disabled={this.state.disableCheckBox}
                            checked={disableMobile}
                            onChange={this.onGetPhone}
                        >
                            若无手机号，请勾选此项，系统会自动填充000开头11位数字作为标识
                        </Checkbox>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>固定电话:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Input
                            style={{ width: 260 }}
                            placeholder="请输入"
                            value={userTelephone}
                            onChange={(e) => this.handleInputChange(e, "userTelephone")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>邮箱:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Input
                            style={{ width: 260 }}
                            placeholder="请输入"
                            value={userEmail}
                            onChange={(e) => this.handleInputChange(e, "userEmail")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>接待时间:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Input
                            style={{ width: 260 }}
                            placeholder="请输入"
                            value={receptionTime}
                            onChange={(e) => this.handleInputChange(e, "receptionTime")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>接待地点:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Input
                            style={{ width: 260 }}
                            placeholder="请输入"
                            value={receptionPlace}
                            onChange={(e) => this.handleInputChange(e, "receptionPlace")}
                        />
                    </div>
                </li>
            </ul>
        );
    };

    render() {
        const { visible, submitting } = this.state;
        return (
            <Modal
                title={`${editRecord ? "修改" : "新增"}待合作医生`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={submitting}
                maskClosable={false}
                width="620px"
            >
                <Spin spinning={submitting}>
                    <div className="modal-content" style={{ padding: "0 20px" }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default PendingDoctorModal;


// WEBPACK FOOTER //
// ./src/components/hospital/doctorInfo/PendingDoctorModal.js